import React from "react";
import { FlatButton, TextField } from "material-ui";

import BaseOverlay from "./base.jsx";

const styles = {
  note: {
    marginTop: "1em",
    fontSize: "0.8em"
  }
};

class TransferOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      recipient: ""
    };

    this.transfer = this.transfer.bind(this);
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {}

  transfer() {
    this.props.onTransfer(this.state.recipient);
  }

  render() {
    let { onRequestClose, bulkCount, typeName, type } = this.props;

    const itemName = typeName || type;

    return (
      <BaseOverlay
        onRequestClose={onRequestClose}
        useMuiDefaultStyle={true}
        actions={[
          <FlatButton label="Cancel" onTouchTap={onRequestClose} />,
          <FlatButton
            primary={true}
            label={`Transfer ${bulkCount ? `${bulkCount} ${itemName}` : ""}`}
            onTouchTap={this.transfer}
            disabled={!this.state.recipient}
          />
        ]}
      >
        <div>Please enter a recipient for the {itemName} transfer.</div>
        <TextField
          floatingLabelText="Recipient email address"
          floatingLabelFixed={true}
          value={this.state.recipient}
          onChange={e => this.setState({ recipient: e.target.value })}
        />
        <div style={styles.note}>
          Note: The transfer will remain pending until the recipient accepts the
          transfer by clicking the link that they will receive via email.
        </div>
      </BaseOverlay>
    );
  }
}

export default TransferOverlay;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/transfer-overlay.jsx